/* eslint-disable global-require */
// import type { ShareTargetPickerResult } from '@line/liff/dist/lib/api/shareTargetPicker/def.d'
import React, { useEffect, useMemo, useState } from 'react'

import { CoverSpinning } from '../components/elements'
import Modal from '../components/modals/Modal'
import TagManager from '../lib/tag-manager'
import getAPI from '../services'

const CampaignPage: React.FC = () => {
    const [noticeModal, setNoticeModal] = useState(false)
    const [profile, setProfile] = useState<{ userId: string }>({ userId: '' })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        function getUserProfile() {
            window.liff.ready.then(window.liff.getProfile).then(setProfile)
        }
        getUserProfile()
    }, [])

    useMemo(() => {
        TagManager.loadEvent({ page: 'line-sharing-campaign' })
    }, [])

    const uploadSharingStatus = async (shared: boolean) => {
        try {
            setLoading(true)
            const { aud } = window.liff.getDecodedIDToken() || {}
            await getAPI().campaignService.putsActivity({
                uid: profile.userId,
                channel: 'LINE',
                channelId: aud || '',
                shared,
            })
            TagManager.popupEvent({
                page: 'line-sharing-campaign',
                field: 'shared',
                action: String(shared),
            })
        } catch (error) {
            console.error('Campaign page', error)
        } finally {
            setLoading(false)
        }
    }

    const onClickShareTargetPicker = async () => {
        const isAllowed = window.liff.isApiAvailable('shareTargetPicker')

        if (!isAllowed) {
            setNoticeModal(true)
            return
        }

        const result = await window.liff.shareTargetPicker([
            {
                altText: 'แนะนำแอป Money Thunder',
                type: 'flex',
                contents: {
                    footer: {
                        type: 'box',
                        contents: [
                            {
                                layout: 'vertical',
                                contents: [
                                    {
                                        margin: 'sm',
                                        text: 'แนะนำแอป Money Thunder',
                                        type: 'text',
                                        wrap: true,
                                        contents: [],
                                    },
                                    {
                                        wrap: true,
                                        contents: [],
                                        text: '✔️ ยื่นกู้รู้ผลใน 15 นาที',
                                        type: 'text',
                                        margin: 'sm',
                                    },
                                    {
                                        wrap: true,
                                        contents: [],
                                        type: 'text',
                                        text: '✔️ รับเงินใน 24 ชม.',
                                        margin: 'none',
                                    },
                                    {
                                        margin: 'none',
                                        wrap: true,
                                        type: 'text',
                                        text: '✔️ ไม่มีค่าธรรมเนียมยื่นกู้',
                                        contents: [],
                                    },
                                    {
                                        size: 'md',
                                        type: 'spacer',
                                    },
                                ],
                                type: 'box',
                            },
                            {
                                type: 'box',
                                layout: 'vertical',
                                contents: [
                                    {
                                        action: {
                                            type: 'uri',
                                            label: 'ดาวน์โหลดแอปและยื่นกู้',
                                            uri: 'https://moneythunder.onelink.me/px1v/b4867767',
                                        },
                                        height: 'sm',
                                        type: 'button',
                                        style: 'primary',
                                        margin: 'none',
                                        color: '#7099B3',
                                    },
                                    {
                                        size: 'xs',
                                        type: 'spacer',
                                    },
                                ],
                            },
                            {
                                type: 'box',
                                layout: 'vertical',
                                contents: [
                                    {
                                        margin: 'none',
                                        style: 'primary',
                                        action: {
                                            type: 'uri',
                                            label: 'สอบถามข้อมูลเพิ่มเติม',
                                            uri: 'http://nav.cx/9f2NKwg',
                                        },
                                        color: '#7099B3',
                                        height: 'sm',
                                        type: 'button',
                                    },
                                    {
                                        type: 'spacer',
                                        size: 'xs',
                                    },
                                ],
                            },
                            {
                                type: 'box',
                                contents: [
                                    {
                                        height: 'sm',
                                        type: 'button',
                                        style: 'primary',
                                        action: {
                                            type: 'uri',
                                            label: 'แชร์บอกเพื่อน',
                                            uri: `https://liff.line.me/${
                                                process.env.SHARING_CAMPAIGN || ''
                                            }`,
                                        },
                                        color: '#7099B3',
                                        margin: 'none',
                                    },
                                ],
                                layout: 'vertical',
                            },
                        ],
                        layout: 'vertical',
                    },
                    type: 'bubble',
                    direction: 'ltr',
                    hero: {
                        type: 'image',
                        url: 'https://firebasestorage.googleapis.com/v0/b/thunder-chatbot.appspot.com/o/referral_banner_oct2020_update.jpg?alt=media&token=1e89d072-2f58-4549-89d1-545cb78fc409',
                        size: 'full',
                        gravity: 'center',
                        aspectMode: 'cover',
                        aspectRatio: '4:3',
                        margin: 'none',
                    },
                },
            },
        ])

        if (result?.status === 'success') {
            await uploadSharingStatus(true)
            window.liff.logout()
            window.liff.closeWindow()
        } else {
            const [major, minor, patch] = (window.liff.getLineVersion() || '').split('.')
            if (minor === undefined) {
                await uploadSharingStatus(false)
                console.log('cancelled share target pick in external browser')
            }

            if (parseInt(major, 10) >= 10 && parseInt(minor, 10) >= 10 && parseInt(patch, 10) > 0) {
                await uploadSharingStatus(false)
                console.log('cancelled share target pick in external browser')
            }
        }
    }

    return (
        <>
            {!noticeModal && loading && <CoverSpinning />}
            {noticeModal && (
                <Modal toggleModal={() => setNoticeModal(!noticeModal)}>
                    <div className="abcs-container">
                        <div className="grid grid-flow-row gap-y-4 py-4">
                            <h4 className="font-bold">เกิดข้อผิดพลาด</h4>
                            <p className="leading-6">
                                กรุณาตรวจสอบ LINE Version บนเครื่องของท่าน กรุณาอัพเดท LINE
                                Application ให้เป็น version ล่าสุด
                            </p>
                        </div>
                    </div>
                </Modal>
            )}
            <div className="abcs-container">
                <div className="py-6">
                    <img src={require('../assets/referral_banner.png')} alt="referral-banner" />
                </div>
                <div>
                    <button
                        type="button"
                        className="abcs-button primary fluid"
                        onClick={onClickShareTargetPicker}
                    >
                        แชร์บอกเพื่อนผ่าน LINE
                    </button>
                </div>
            </div>
        </>
    )
}

export default CampaignPage
